import SyosController from './SyosController';
import SyosGlobalConfig from './SyosGlobalConfig';

window.tnew.syos = {
  SyosController,
  config: SyosGlobalConfig,
};



// WEBPACK FOOTER //
// ./src/syos/syos.js